import { render, staticRenderFns } from "./verified-days.vue?vue&type=template&id=6ad0fd72"
import script from "./verified-days.vue?vue&type=script&lang=js"
export * from "./verified-days.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports